import { List } from 'antd';
import React from 'react';
import LearningItem from '../learningItem';
import PropTypes from 'prop-types';
import { getString } from '@nackle/intl-tools';
import classNames from 'classnames';
import './styles.less';
import { breakpointSpecs } from './config';

const localeMap = {
    emptyText: {
        course: 'courseList.empty',
        curriculum: 'courseList.empty', // this should be different
    }
};

const LearningList = ( { displayType, data, learningType, isLoading, className } ) => {

    return <>
        <List
            grid={ {
                gutter: [ 40, 30 ],
                ...breakpointSpecs
            } }
            dataSource={ data }
            className={ classNames( 'learning-list', `learning-list-${ displayType }`, className, { hidden: displayType != 'card' } ) }
            locale={ { emptyText: getString( localeMap.emptyText[ learningType ] ) } }
            renderItem={ ( item ) => (
                <List.Item
                    key={ item.id }>
                    <LearningItem
                        learningObject={ item }
                        isLoading={ isLoading }
                        displayType={ displayType }
                        learningType={ learningType }
                    />
                </List.Item>
            ) }
        />
        <List
            dataSource={ data }
            className={ classNames( 'learning-list', `learning-list-${ displayType }`, className, { hidden: displayType == 'card' } ) }
            locale={ { emptyText: getString( localeMap.emptyText[ learningType ] ) } }
            renderItem={ ( item ) => (
                <List.Item
                    key={ item.id }>
                    <LearningItem
                        learningObject={ item }
                        isLoading={ isLoading }
                        displayType={ displayType }
                        learningType={ learningType }
                    />
                </List.Item>
            ) }
        />
    </>;

};

LearningList.propTypes = {
    learningType: PropTypes.oneOf( [ 'course', 'curriculum', 'resource' ] ),
    displayType: PropTypes.oneOf( [ 'card', 'list', 'search' ] ).isRequired,
    data: PropTypes.arrayOf( PropTypes.object ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

LearningList.defaultProps = {
    className: '',
};

export default LearningList;